import { isTileVerticallyVisible } from './is-tile-visible';
import { toggleImageTileExpansion } from './toggle-image-tile-expansion';

export const ensureSelectedColorIsVisible = (colorImageTileContainer: HTMLElement, showMoreColorsLink: HTMLElement, productId: string) => {
    const colorImageTiles = colorImageTileContainer.querySelectorAll<HTMLElement>('.js_pdp_dimension-selection__color-tile');
    colorImageTiles.forEach(tile => {
        const tileIsSelected = tile.dataset.qaDimensionItem === 'selected';
        if (tileIsSelected && !isTileVerticallyVisible(colorImageTileContainer, tile)) {
            toggleImageTileExpansion(showMoreColorsLink, colorImageTileContainer, productId);
        }
    });
};
